module.exports = __webpack_public_path__ + "static/order-change-status-6a9de5df390157c1050a3935e300dd80.png";